export const addCommas = (amount) => {
    if (amount === undefined || amount === null || isNaN(amount)) {
        return ''; // or return '0' or any other default value you prefer
    }
    // Convert the amount to a string and split into integer and decimal parts
    let parts = amount.toString().split('.');
    let integerPart = parts[0];
    let decimalPart = parts.length > 1 ? '.' + parts[1] : '';
    if (integerPart === '0') {
        return '0' + decimalPart; // Return "0" or "0.00" etc.
    }

    // Add commas to the integer part
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Combine the integer and decimal parts
    return integerPart + decimalPart;
}

export const cleanSpecialNaming = (text="") => {
    return text.replace(/_x000D_/g, ' ').trim(); // Replace with space and trim
}

export const base64ToBlob = (base64Data, fileExtension) => {
   
    let contentType = '';

    switch (fileExtension.toLowerCase()) {
        case 'pdf':
            contentType = 'application/pdf';
            break;
        case 'txt':
            contentType = 'text/plain';
            break;
        case 'html':
            contentType = 'text/html';
            break;
        case 'json':
            contentType = 'application/json';
            break;
        case 'csv':
            contentType = 'text/csv';
            break;
        case 'jpg':
        case 'jpeg':
            contentType = 'image/jpeg';
            break;
        case 'png':
            contentType = 'image/png';
            break;
        case 'gif':
            contentType = 'image/gif';
            break;
        case 'svg':
            contentType = 'image/svg+xml';
            break;
        case 'zip':
            contentType = 'application/zip';
            break;
        case 'doc':
            contentType = 'application/msword';
            break;
        case 'docx':
            contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            break;
        case 'xls':
            contentType = 'application/vnd.ms-excel';
            break;
        case 'xlsx':
            contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            break;
        case 'mp3':
            contentType = 'audio/mpeg';
            break;
        case 'mp4':
            contentType = 'video/mp4';
            break;
        case 'webm':
            contentType = 'video/webm';
            break;
        case 'ogg':
            contentType = 'audio/ogg';
            break;
        default:
            contentType = 'application/octet-stream'; // fallback for unknown types
            break;
    }
    
    // const byteCharacters = atob(base64WithoutPrefix);
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    // const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset++) {

        byteNumbers[offset] = byteCharacters.charCodeAt(offset);
    }
  
      const byteArray = new Uint8Array(byteNumbers);
    
  
    return new Blob([byteArray], { type: contentType });
}

export const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            resolve(reader.result);
        };
        reader.onerror = (error) => {
            reject(error);
        };
        reader.readAsDataURL(file);
    });
}

export const getContentTypeFromBase64 = (base64String) => {
    const matches = base64String.match(/^data:(.+);base64,/);
    if (matches && matches.length > 1) {
      return matches[1];
    }
    return null;
}
export const formatDate = (dateString) => {
  if (!dateString) return "";
  const parts = dateString.split('-');
  if (parts.length === 3) {
    const year = parts[0];
    const month = parts[1].padStart(2, '0');
    const day = parts[2].padStart(2, '0'); 
    if (year === '0001' || month === '00' || day === '00') return "";
    const date = new Date(`${day}/${month}/${year}`);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split('T')[0];
  }
  return "";
};

  export const isInvalidDate = (dateValue) => {
    if (!dateValue) return true;
    // Check for various invalid date patterns
    return (
      dateValue.includes('0001-01-01') || 
      dateValue.includes('01/01/0001') ||
      dateValue.startsWith('0001-') ||
      new Date(dateValue).getFullYear() < 1900 // Consider dates before 1900 as invalid
    );
  };